import "./CodesAndPolicies.css";

const CodesAndPolicies = () => {
  return (
    <div>
      <div className="hero_img policy_img">
      <img src="/assets/cp_banner.jpg" alt="" />

      <div className="hero_title hero_title_clr">Codes and Policies</div>

      </div>
      <div className="container2">
        <div className="policies_flex portp_div2 container ">
          <div className="portp_div31">
            <img
              src="/assets/CodesAndPolicies/CodesAndPoliciesimg2.jpg"
              alt=""
            />
          </div>
          <div className="portp_div21  ">
            <h2>
              Health, Safety, <br /> Security & Environment Policy
            </h2>
            <p>
              We at Crest Digitel believe that the Occupational Health, Safety,
              and Security of human beings overrides all other business targets,
              especially with regard to the environment at large.
            </p>
            <p>
              We not only believe in fostering a safe working environment but
              also ensure that our commitment translates into a culture where
              our employees and our business partners have a safe and healthy
              working atmosphere that improves their well-being and prevents
              occupational ill health and work-related injuries.
            </p>
            <p>
              We have an HSSE policy which is another testament to our
              commitment to achieve our goal of ZERO serious safety incidents,
              ZERO incidents that are considered high risk and ZERO incidents
              that are considered detrimental to the environment.
            </p>
            <a               target="_blank"
              rel="noopener noreferrer" href="/assets/CodesAndPolicies/CREST_HSSE-Policy.pdf" className="policies_link">
              Download HSSE Policy
            </a>
          </div>
        </div>

        <div className="portp_div2 container ">
          <div className="portp_div21  ">
            <h2>
              Code of Business Conduct and <br />
              Ethics
            </h2>
            <p>
              Crest Digitel is dedicated to carrying out all its activities in a
              way that is completely compliant with all applicable rules and
              regulations.
            </p>
            <p>
              We have an HSSE policy which is another testament to our
              commitment to achieve our goal of ZERO serious safety incidents,
              ZERO incidents that are considered high risk and ZERO incidents
              that are considered detrimental to the environment.
            </p>
            <a               target="_blank"
              rel="noopener noreferrer" href="/assets/CodesAndPolicies/CrestDigitel-Code-of-Business-Conduct-and-Ethics.pdf" className="policies_link">
              Download CoC Policy
            </a>
          </div>
          <div className="portp_div31">
            <img
              src="/assets/CodesAndPolicies/CodesAndPoliciesimg3.jpg"
              alt=""
            />
          </div>
        </div>

        <div className="portp_div2 policies_flex container ">
          <div className="portp_div31">
            <img
              src="/assets/CodesAndPolicies/CodesAndPoliciesimg4.jpg"
              alt=""
            />
          </div>
          <div className="portp_div21  ">
            <h2>Whistle Blower Policy</h2>
            <p>
              As part of Crest Digitel’s Whistleblower Policy, employees and
              other stakeholders are encouraged to express their concerns or
              voices in relation to any misconduct, bad or harmful behavior,
              illegal and unethical behaviour, loss of intellectual property
              assets, such as brands and patents, or the disclosure of highly
              confidential and private business information, regardless of
              whether or not the conduct was wrong. Through this policy, the
              organization hopes to encourage the workforce to speak up if they
              witness wrongdoing in the workplace and to build a sense of
              belonging by fostering a culture of openness and transparency.
            </p>
            <a               target="_blank"
              rel="noopener noreferrer" href="/assets/CodesAndPolicies/CrestDigitel-Whistle-Blower-Policy.pdf" className="policies_link">
              Download Whistle Blower Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodesAndPolicies;
